import React from 'react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import { MapPin, Phone, Mail, Clock, Instagram, Twitter, Facebook } from 'lucide-react';
import { businessInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand & Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/mvt79ma9_29A81CA4-6157-450E-BDCF-09CA0369D517.png"
                alt="Big Dog Kush" 
                className="h-16 w-auto mb-4 filter brightness-0 invert"
              />
              <p className="text-gray-400 mb-4 leading-relaxed">
                {businessInfo.location}'s premier cannabis destination. Premium quality, unmatched service, authentic experience.
              </p>
              <div className="flex space-x-4">
                <Button variant="ghost" size="sm" className="text-gray-400 hover:text-green-400 p-2">
                  <Instagram size={20} />
                </Button>
                <Button variant="ghost" size="sm" className="text-gray-400 hover:text-green-400 p-2">
                  <Twitter size={20} />
                </Button>
                <Button variant="ghost" size="sm" className="text-gray-400 hover:text-green-400 p-2">
                  <Facebook size={20} />
                </Button>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Shop</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">All Products</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Flower</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Pre-Rolls</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Concentrates</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Edibles</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Accessories</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Company</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Our Story</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Quality Promise</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Lab Results</a></li>
              <li><a href="#" className="text-gray-400 hover:text-green-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">{businessInfo.location}</p>
                  <p className="text-gray-500 text-sm">{businessInfo.socialHandle}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-green-400 flex-shrink-0" />
                <p className="text-gray-300">{businessInfo.phone}</p>
              </div>
              
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-green-400 flex-shrink-0" />
                <p className="text-gray-300">{businessInfo.email}</p>
              </div>
              
              <div className="flex items-start gap-3">
                <Clock size={18} className="text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  {Object.entries(businessInfo.hours).map(([day, hours]) => (
                    <p key={day} className="text-gray-300 text-sm">{day}: {hours}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-gray-800 mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-gray-500">
            <p>© 2024 {businessInfo.name}. All rights reserved.</p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-green-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-green-400 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-green-400 transition-colors">Cookie Policy</a>
            </div>
          </div>
          
          {/* Compliance Disclaimer */}
          <div className="text-sm text-gray-500 text-center md:text-right">
            <p className="font-medium text-green-400 mb-1">Legal Notice</p>
            <p>{businessInfo.disclaimer}</p>
            <p className="mt-1">Please consume responsibly.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;